import { Component } from '@angular/core';
@Component({
  selector: 'app-thank-you-for-contact-page',
  templateUrl: './thank-you-for-contact-page.component.html',
  styleUrls: ['./thank-you-for-contact-page.component.scss'],
})
export class ThankYouForContactPageComponent {}
